import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { SuporteWhatsappService } from '../../services/suporte-whatsapp.service';
import { ConstantsService } from '../../fidelidade/ConstantsService';
import { AutorizacaoService } from '../../services/autorizacao.service';
import { UsuarioService } from '../../services/usuario.service';
import { SuporteTicketsService } from '../../services/suporte-tickets.service';
import { WhatsappService } from '../../services/whatsapp.service';

@Component({
  selector: 'app-suporte-contexto-whatsapp',
  templateUrl: './suporte-contexto-whatsapp.component.html',
  styleUrls: ['./suporte-contexto-whatsapp.component.scss']
})
export class SuporteContextoWhatsappComponent implements OnInit, OnDestroy {
  grupoId = '';
  nomeGrupo = '';
  modoFilaOperador = false;
  contexto: any;
  erro = '';
  carregando = false;
  vinculando = false;
  desvinculando = false;
  exibindoDesvincular = false;
  justificativaDesvinculo = '';
  buscandoEmpresas = false;
  buscouEmpresas = false;
  termoBusca = '';
  empresas: any[] = [];
  empresaSelecionada: any;
  usuario: any;
  empresa: any;
  salvandoAssinaturaWhatsapp = false;
  meusTickets: any[] = [];
  meusTicketsTotal = 0;
  carregandoMeusTickets = false;
  erroMeusTickets = '';
  ticketsDestaque: any[] = [];
  ticketsDestaqueTotal = 0;
  carregandoTicketsDestaque = false;
  erroTicketsDestaque = '';
  assumindoTicketId: number | null = null;
  acoesRapidas: any;
  carregandoAcoesRapidas = false;
  erroAcoesRapidas = '';
  aprovandoCampanhaId: number | null = null;
  fechandoLojaTempo: number | null = null;
  abrindoLoja = false;
  desbloqueandoEmergencial = false;
  mensagemFechamentoLoja = '';
  acaoRapidaPendente: any;
  solicitacaoClienteAcaoRapida = '';
  motivoAcaoRapida = '';
  erroAcaoRapida = '';
  clientePkt = false;
  exibindoSolicitacaoSuporte = false;
  descricaoSolicitacaoSuporte = '';
  enviandoSolicitacaoSuporte = false;
  erroSolicitacaoSuporte = '';
  ticketClienteCriado: any;
  contextoClientePkt: any;
  carregandoClientePkt = false;
  erroClientePkt = '';

  private assinaturas = new Subscription();
  private timeoutBuscaEmpresas: any;
  private numeroContexto = 0;
  private numeroBuscaEmpresas = 0;
  private numeroAcoesRapidas = 0;

  constructor(private suporteWhatsappService: SuporteWhatsappService,
              private activatedRoute: ActivatedRoute,
              private constantsService: ConstantsService,
              private autorizacaoService: AutorizacaoService,
              private usuarioService: UsuarioService,
              private suporteTicketsService: SuporteTicketsService,
              private whatsappService: WhatsappService) {
  }

  ngOnInit() {
    this.usuario = this.autorizacaoService.getUser() || {};
    this.notifiqueExtensaoAssinarMensagens();

    this.assinaturas.add(this.autorizacaoService.usuarioLogado$.subscribe(usuario => {
      if (usuario) {
        this.usuario = usuario;
        this.notifiqueExtensaoAssinarMensagens();

        if (this.contexto && !this.contexto.elegivel && !this.clientePkt) {
          this.carregueFilasOperador();
        }
      }
    }));

    this.assinaturas.add(this.constantsService.empresa$.subscribe(empresa => {
      if (empresa) {
        this.empresa = empresa;
        if (this.grupoId || this.modoFilaOperador) {
          this.carregueContexto();
        }
      }
    }));

    this.assinaturas.add(combineLatest([
      this.activatedRoute.params,
      this.activatedRoute.queryParams
    ]).subscribe(([params, queryParams]) => {
      this.grupoId = this.decode(params.grupo);
      this.modoFilaOperador = !this.grupoId;
      this.nomeGrupo = this.modoFilaOperador ? 'Fila do suporte' : this.normalizeNome(queryParams.nome);
      this.carregueContexto();
    }));
  }

  ngOnDestroy() {
    this.assinaturas.unsubscribe();
    clearTimeout(this.timeoutBuscaEmpresas);
  }

  podeUsarModoSuporte(): boolean {
    if (!this.empresa || !this.usuario) {
      return true;
    }

    return Number(this.empresa.id) === 1 && (this.usuario.admin || this.usuario.superadmin);
  }

  salveAssinaturaWhatsapp() {
    this.salvandoAssinaturaWhatsapp = true;
    this.erro = '';

    this.usuarioService.salveAssinatura(this.usuario.assinarMensagens).then(() => {
      this.autorizacaoService.atualizeUsuario(this.usuario);
      this.notifiqueExtensaoAssinarMensagens();
    }).catch(erro => {
      this.erro = erro || 'Não foi possível salvar a assinatura das mensagens.';
    }).finally(() => {
      this.salvandoAssinaturaWhatsapp = false;
    });
  }

  private notifiqueExtensaoAssinarMensagens() {
    if (!this.usuario || !this.usuario.nome) {
      return;
    }

    window.parent.postMessage({
      tipo: 'NOVA_MENSAGEM', text: {
        tipo: 'SALVAR_ASSINATURA',
        assinatura: this.usuario.assinarMensagens ? this.usuario.nome : ''
      }
    }, '*');
  }

  carregueContexto() {
    const numeroContexto = ++this.numeroContexto;

    if (!this.empresa) {
      this.carregando = true;
      return;
    }

    if (!this.grupoId) {
      this.reinicieEstadoContexto();
      clearTimeout(this.timeoutBuscaEmpresas);
      this.carregando = false;
      this.contexto = {
        elegivel: false,
        vinculado: false,
        filaOperador: true
      };
      this.carregueFilasOperador();
      return;
    }

    if (this.deveExibirClientePkt()) {
      this.reinicieEstadoContexto();
      clearTimeout(this.timeoutBuscaEmpresas);
      this.carregando = false;
      this.clientePkt = true;
      this.contexto = {
        elegivel: false,
        vinculado: false,
        clientePkt: true,
        grupo: {
          whatsappChatId: this.grupoId,
          nomeGrupo: this.nomeGrupo,
          prefixo: 'PKT'
        }
      };
      this.carregueContextoClientePkt();
      return;
    }

    this.carregando = true;
    this.reinicieEstadoContexto();
    clearTimeout(this.timeoutBuscaEmpresas);

    this.suporteWhatsappService.obtenhaContexto(this.grupoId, this.nomeGrupo).then(contexto => {
      if (numeroContexto !== this.numeroContexto || !this.mesmoGrupo(contexto)) {
        return;
      }

      this.contexto = contexto;

      if (!contexto.elegivel) {
        this.carregueFilasOperador();
      } else if (contexto.vinculado) {
        this.carregueAcoesRapidas();
      }
    }).catch(erro => {
      if (numeroContexto !== this.numeroContexto) {
        return;
      }

      this.erro = erro;
    }).finally(() => {
      if (numeroContexto !== this.numeroContexto) {
        return;
      }

      this.carregando = false;
    });
  }

  busqueEmpresas() {
    clearTimeout(this.timeoutBuscaEmpresas);
    const numeroBusca = ++this.numeroBuscaEmpresas;

    this.buscandoEmpresas = true;
    this.buscouEmpresas = true;
    this.erro = '';
    this.empresas = [];
    this.empresaSelecionada = null;

    this.suporteWhatsappService.listeEmpresas(this.termoBusca).then(empresas => {
      if (numeroBusca !== this.numeroBuscaEmpresas) {
        return;
      }

      this.empresas = empresas || [];
    }).catch(erro => {
      if (numeroBusca !== this.numeroBuscaEmpresas) {
        return;
      }

      this.erro = erro || 'Não foi possível buscar empresas.';
    }).finally(() => {
      if (numeroBusca !== this.numeroBuscaEmpresas) {
        return;
      }

      this.buscandoEmpresas = false;
    });
  }

  agendeBuscaEmpresas() {
    clearTimeout(this.timeoutBuscaEmpresas);

    this.timeoutBuscaEmpresas = setTimeout(() => {
      this.busqueEmpresas();
    }, 350);
  }

  selecioneEmpresa(empresa: any) {
    this.empresaSelecionada = empresa;
  }

  vinculeGrupo() {
    if (!this.empresaSelecionada) {
      this.erro = 'Selecione uma empresa para vincular ao grupo.';
      return;
    }

    this.vinculando = true;
    this.erro = '';
    const numeroContexto = this.numeroContexto;

    this.suporteWhatsappService.vinculeGrupo(
      this.grupoId,
      this.nomeGrupo,
      this.empresaSelecionada.id
    ).then(contexto => {
      if (numeroContexto !== this.numeroContexto || !this.mesmoGrupo(contexto)) {
        return;
      }

      this.contexto = contexto;
      this.empresas = [];
      this.empresaSelecionada = null;
      this.exibindoDesvincular = false;
      this.justificativaDesvinculo = '';
      this.carregueAcoesRapidas();
    }).catch(erro => {
      if (numeroContexto !== this.numeroContexto) {
        return;
      }

      this.erro = erro;
    }).finally(() => {
      if (numeroContexto !== this.numeroContexto) {
        return;
      }

      this.vinculando = false;
    });
  }

  abraDesvincular() {
    this.exibindoDesvincular = true;
    this.justificativaDesvinculo = '';
    this.erro = '';
  }

  canceleDesvincular() {
    this.exibindoDesvincular = false;
    this.justificativaDesvinculo = '';
  }

  abraSolicitacaoSuporte() {
    this.exibindoSolicitacaoSuporte = true;
    this.descricaoSolicitacaoSuporte = '';
    this.erroSolicitacaoSuporte = '';
  }

  canceleSolicitacaoSuporte() {
    if (this.enviandoSolicitacaoSuporte) {
      return;
    }

    this.exibindoSolicitacaoSuporte = false;
    this.descricaoSolicitacaoSuporte = '';
    this.erroSolicitacaoSuporte = '';
  }

  envieSolicitacaoSuporte() {
    const descricao = String(this.descricaoSolicitacaoSuporte || '').trim();

    if (!descricao) {
      this.erroSolicitacaoSuporte = 'Descreva sua solicitação.';
      return;
    }

    this.enviandoSolicitacaoSuporte = true;
    this.erroSolicitacaoSuporte = '';

    this.suporteTicketsService.crieClientePkt({
      chatId: this.grupoId,
      nomeGrupo: this.nomeGrupo,
      descricao
    }).then(ticket => {
      this.ticketClienteCriado = ticket;
      this.envieMensagemSolicitacaoNoGrupo(ticket, descricao);
      this.exibindoSolicitacaoSuporte = false;
      this.descricaoSolicitacaoSuporte = '';
    }).catch(erro => {
      this.erroSolicitacaoSuporte = erro || 'Não foi possível abrir a solicitação.';
    }).finally(() => {
      this.enviandoSolicitacaoSuporte = false;
    });
  }

  carregueContextoClientePkt() {
    this.carregandoClientePkt = true;
    this.erroClientePkt = '';
    this.contextoClientePkt = null;

    this.suporteTicketsService.obtenhaContextoClientePkt(this.grupoId, this.nomeGrupo).then(contexto => {
      this.contextoClientePkt = contexto;
    }).catch(erro => {
      this.erroClientePkt = erro || 'Não foi possível carregar o vínculo deste grupo.';
    }).finally(() => {
      this.carregandoClientePkt = false;
    });
  }

  desvinculeGrupo() {
    if (!this.justificativaDesvinculo || !String(this.justificativaDesvinculo).trim()) {
      this.erro = 'Informe a justificativa para desvincular o grupo.';
      return;
    }

    this.desvinculando = true;
    this.erro = '';
    const numeroContexto = this.numeroContexto;

    this.suporteWhatsappService.desvinculeGrupo(
      this.grupoId,
      this.nomeGrupo,
      this.justificativaDesvinculo
    ).then(contexto => {
      if (numeroContexto !== this.numeroContexto || !this.mesmoGrupo(contexto)) {
        return;
      }

      this.contexto = contexto;
      this.empresaSelecionada = null;
      this.exibindoDesvincular = false;
      this.justificativaDesvinculo = '';
    }).catch(erro => {
      if (numeroContexto !== this.numeroContexto) {
        return;
      }

      this.erro = erro;
    }).finally(() => {
      if (numeroContexto !== this.numeroContexto) {
        return;
      }

      this.desvinculando = false;
    });
  }

  textoAcaoHistorico(acao: string): string {
    const mapa: any = {
      VINCULAR: 'Vinculou',
      DESVINCULAR: 'Desvinculou'
    };

    return mapa[acao] || acao;
  }

  carregueFilasOperador() {
    this.carregueMeusTickets();
    this.carregueTicketsDestaque();
  }

  carregueAcoesRapidas() {
    const empresaId = this.obtenhaEmpresaSuporteId();
    const numeroAcoes = ++this.numeroAcoesRapidas;

    if (!empresaId) {
      this.acoesRapidas = null;
      return;
    }

    this.carregandoAcoesRapidas = true;
    this.erroAcoesRapidas = '';

    this.suporteWhatsappService.obtenhaAcoesRapidas(empresaId).then(resumo => {
      if (numeroAcoes !== this.numeroAcoesRapidas) {
        return;
      }

      this.acoesRapidas = resumo;
    }).catch(erro => {
      if (numeroAcoes !== this.numeroAcoesRapidas) {
        return;
      }

      this.erroAcoesRapidas = erro || 'Não foi possível carregar as ações rápidas.';
    }).finally(() => {
      if (numeroAcoes !== this.numeroAcoesRapidas) {
        return;
      }

      this.carregandoAcoesRapidas = false;
    });
  }

  aproveCampanha(campanha: any) {
    if (!this.obtenhaEmpresaSuporteId() || !campanha || !campanha.id) {
      return;
    }

    this.abraConfirmacaoAcaoRapida({
      tipo: 'APROVAR_CAMPANHA',
      titulo: 'Aprovar campanha #' + campanha.id,
      campanha
    });
  }

  fecheLoja(tempo: number) {
    if (!this.obtenhaEmpresaSuporteId()) {
      return;
    }

    this.abraConfirmacaoAcaoRapida({
      tipo: 'FECHAR_LOJA',
      titulo: 'Fechar loja por ' + tempo + ' min',
      tempo
    });
  }

  fecheLojaHoje() {
    if (!this.obtenhaEmpresaSuporteId()) {
      return;
    }

    this.abraConfirmacaoAcaoRapida({
      tipo: 'FECHAR_LOJA',
      titulo: 'Fechar loja hoje',
      tempo: this.obtenhaMinutosRestantesHoje()
    });
  }

  abraLoja() {
    if (!this.obtenhaEmpresaSuporteId()) {
      return;
    }

    this.abraConfirmacaoAcaoRapida({
      tipo: 'ABRIR_LOJA',
      titulo: 'Reabrir loja'
    });
  }

  desbloqueieEmergencialmente() {
    if (!this.obtenhaEmpresaSuporteId() || !this.podeDesbloqueioEmergencial()) {
      return;
    }

    this.abraConfirmacaoAcaoRapida({
      tipo: 'DESBLOQUEIO_EMERGENCIAL',
      titulo: 'Desbloqueio emergencial'
    });
  }

  canceleAcaoRapida() {
    if (this.executandoAcaoRapida()) {
      return;
    }

    this.limpeConfirmacaoAcaoRapida();
  }

  confirmeAcaoRapida() {
    const empresaId = this.obtenhaEmpresaSuporteId();
    const solicitacaoCliente = this.normalizeTexto(this.solicitacaoClienteAcaoRapida);
    const motivoAlteracao = this.normalizeTexto(this.motivoAcaoRapida);

    if (!empresaId || !this.acaoRapidaPendente) {
      return;
    }

    if (!solicitacaoCliente) {
      this.erroAcaoRapida = 'Informe a solicitação original do cliente.';
      return;
    }

    if (!motivoAlteracao) {
      this.erroAcaoRapida = 'Informe o motivo para realizar a alteração.';
      return;
    }

    const auditoria = {
      solicitacaoCliente,
      motivoAlteracao,
      suporteGrupoWhatsappId: this.contexto && this.contexto.grupo ? this.contexto.grupo.id : null
    };
    const acao = this.acaoRapidaPendente;

    this.erroAcaoRapida = '';
    this.erroAcoesRapidas = '';

    if (acao.tipo === 'APROVAR_CAMPANHA') {
      this.executeAprovarCampanha(empresaId, acao.campanha, auditoria);
      return;
    }

    if (acao.tipo === 'FECHAR_LOJA') {
      this.executeFecharLoja(empresaId, acao.tempo, auditoria);
      return;
    }

    if (acao.tipo === 'ABRIR_LOJA') {
      this.executeAbrirLoja(empresaId, auditoria);
      return;
    }

    if (acao.tipo === 'DESBLOQUEIO_EMERGENCIAL') {
      this.executeDesbloqueioEmergencial(empresaId, auditoria);
    }
  }

  executandoAcaoRapida(): boolean {
    return this.aprovandoCampanhaId !== null || this.fechandoLojaTempo !== null || this.abrindoLoja || this.desbloqueandoEmergencial;
  }

  private executeAprovarCampanha(empresaId: number, campanha: any, auditoria: any) {
    if (!campanha || !campanha.id) {
      return;
    }

    this.aprovandoCampanhaId = Number(campanha.id);

    this.suporteWhatsappService.aproveCampanha(empresaId, campanha.id, auditoria).then(resposta => {
      this.atualizeCampanhaAprovadaNaTela(campanha.id, resposta && resposta.campanha);
      this.limpeConfirmacaoAcaoRapida();
    }).catch(erro => {
      this.erroAcaoRapida = erro || 'Não foi possível aprovar a campanha.';
    }).finally(() => {
      this.aprovandoCampanhaId = null;
    });
  }

  private atualizeCampanhaAprovadaNaTela(campanhaId: number, campanhaAtualizada: any) {
    if (!this.acoesRapidas || !this.acoesRapidas.campanhasPendentes) {
      return;
    }

    const campanha = this.acoesRapidas.campanhasPendentes.find((item: any) => Number(item.id) === Number(campanhaId));

    if (!campanha) {
      return;
    }

    Object.assign(campanha, campanhaAtualizada || {}, {
      statusAprovacao: 'Aprovada'
    });
  }

  private executeFecharLoja(empresaId: number, tempo: number, auditoria: any) {
    this.fechandoLojaTempo = tempo;

    this.suporteWhatsappService.fecheLoja(empresaId, tempo, this.mensagemFechamentoLoja, auditoria).then(loja => {
      if (!this.acoesRapidas) {
        this.acoesRapidas = {};
      }

      this.acoesRapidas.loja = loja;
      this.limpeConfirmacaoAcaoRapida();
    }).catch(erro => {
      this.erroAcaoRapida = erro || 'Não foi possível fechar a loja.';
    }).finally(() => {
      this.fechandoLojaTempo = null;
    });
  }

  private executeAbrirLoja(empresaId: number, auditoria: any) {
    this.abrindoLoja = true;

    this.suporteWhatsappService.abraLoja(empresaId, auditoria).then(loja => {
      if (!this.acoesRapidas) {
        this.acoesRapidas = {};
      }

      this.acoesRapidas.loja = loja;
      this.limpeConfirmacaoAcaoRapida();
    }).catch(erro => {
      this.erroAcaoRapida = erro || 'Não foi possível reabrir a loja.';
    }).finally(() => {
      this.abrindoLoja = false;
    });
  }

  private executeDesbloqueioEmergencial(empresaId: number, auditoria: any) {
    this.desbloqueandoEmergencial = true;

    this.suporteWhatsappService.desbloqueieEmergencialmente(empresaId, auditoria).then(retorno => {
      if (!this.acoesRapidas) {
        this.acoesRapidas = {};
      }

      this.acoesRapidas.empresa = retorno && retorno.empresa ? retorno.empresa : this.acoesRapidas.empresa;
      this.limpeConfirmacaoAcaoRapida();
    }).catch(erro => {
      this.erroAcaoRapida = erro || 'Não foi possível fazer o desbloqueio emergencial.';
    }).finally(() => {
      this.desbloqueandoEmergencial = false;
    });
  }

  private abraConfirmacaoAcaoRapida(acao: any) {
    this.acaoRapidaPendente = acao;
    this.solicitacaoClienteAcaoRapida = '';
    this.motivoAcaoRapida = '';
    this.erroAcaoRapida = '';
  }

  private limpeConfirmacaoAcaoRapida() {
    this.acaoRapidaPendente = null;
    this.solicitacaoClienteAcaoRapida = '';
    this.motivoAcaoRapida = '';
    this.erroAcaoRapida = '';
  }

  private obtenhaMinutosRestantesHoje(): number {
    const agora = new Date();
    const fimDoDia = new Date();

    fimDoDia.setHours(23, 59, 59, 999);

    return Math.max(1, Math.ceil((fimDoDia.getTime() - agora.getTime()) / (1000 * 60)));
  }

  textoBloqueioEmpresa(): string {
    const empresaResumo = this.acoesRapidas && this.acoesRapidas.empresa;

    if (!empresaResumo) {
      return 'Bloqueio não carregado';
    }

    if (empresaResumo.bloqueada) {
      return 'Empresa bloqueada';
    }

    if (empresaResumo.diasAteBloqueio == null) {
      return 'Sem bloqueio programado';
    }

    if (empresaResumo.diasAteBloqueio < 0) {
      return 'Bloqueio vencido';
    }

    if (empresaResumo.diasAteBloqueio === 0) {
      return 'Bloqueia hoje';
    }

    if (empresaResumo.diasAteBloqueio === 1) {
      return 'Bloqueia amanhã';
    }

    return 'Bloqueia em ' + empresaResumo.diasAteBloqueio + ' dias';
  }

  classeBloqueioEmpresa(): string {
    const empresaResumo = this.acoesRapidas && this.acoesRapidas.empresa;

    if (!empresaResumo) {
      return '';
    }

    if (empresaResumo.bloqueada) {
      return 'status-critico';
    }

    if (empresaResumo.diasAteBloqueio == null) {
      return '';
    }

    if (empresaResumo.diasAteBloqueio <= 0) {
      return 'status-critico';
    }

    if (empresaResumo.diasAteBloqueio <= 5) {
      return 'status-alerta';
    }

    return 'status-ok';
  }

  podeDesbloqueioEmergencial(): boolean {
    const empresaResumo = this.acoesRapidas && this.acoesRapidas.empresa;

    return !!(empresaResumo && empresaResumo.bloqueada && empresaResumo.desbloqueioEmergencialDisponivel);
  }

  labelMotivoAcaoRapida(): string {
    return this.acaoRapidaPendente && this.acaoRapidaPendente.tipo === 'DESBLOQUEIO_EMERGENCIAL'
      ? 'Justificativa'
      : 'Motivo da alteração';
  }

  textoFormasPagamento(formasPagamento: string): string {
    if (!formasPagamento) {
      return 'Não informado';
    }

    return String(formasPagamento)
      .replace(/cartao-credito/g, 'Cartão')
      .replace(/credit_card/g, 'Cartão')
      .replace(/bank_slip/g, 'Boleto')
      .replace(/pix/g, 'Pix')
      .replace(/,/g, ', ');
  }

  textoTempoFechamento(loja: any): string {
    if (!loja || !loja.fechada || loja.segundosRestantes == null || loja.segundosRestantes < 0) {
      return '';
    }

    const minutos = Math.ceil(loja.segundosRestantes / 60);

    if (minutos <= 1) {
      return 'menos de 1 min restante';
    }

    return minutos + ' min restantes';
  }

  campanhaAprovada(campanha: any): boolean {
    return campanha && campanha.statusAprovacao === 'Aprovada';
  }

  carregueMeusTickets() {
    if (!this.usuario || !this.usuario.id) {
      return;
    }

    this.carregandoMeusTickets = true;
    this.erroMeusTickets = '';

    this.suporteTicketsService.liste({
      responsavelUsuarioId: this.usuario.id,
      somenteAbertos: true,
      inicio: 0,
      quantidade: 30
    }).then(retorno => {
      this.meusTickets = retorno && retorno.tickets ? retorno.tickets : [];
      this.meusTicketsTotal = retorno && retorno.total ? retorno.total : this.meusTickets.length;
    }).catch(erro => {
      this.erroMeusTickets = erro || 'Não foi possível carregar seus tickets abertos.';
    }).finally(() => {
      this.carregandoMeusTickets = false;
    });
  }

  carregueTicketsDestaque() {
    if (!this.usuario || !this.usuario.id) {
      return;
    }

    this.carregandoTicketsDestaque = true;
    this.erroTicketsDestaque = '';

    this.suporteTicketsService.liste({
      excluirResponsavelUsuarioId: this.usuario.id,
      somenteAbertos: true,
      destaqueOperador: true,
      inicio: 0,
      quantidade: 3
    }).then(retorno => {
      this.ticketsDestaque = retorno && retorno.tickets ? retorno.tickets : [];
      this.ticketsDestaqueTotal = retorno && retorno.total ? retorno.total : this.ticketsDestaque.length;
    }).catch(erro => {
      this.erroTicketsDestaque = erro || 'Não foi possível carregar tickets em destaque.';
    }).finally(() => {
      this.carregandoTicketsDestaque = false;
    });
  }

  assumaTicketDestaque(ticket: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    if (!ticket || !ticket.id) {
      return;
    }

    this.assumindoTicketId = Number(ticket.id);
    this.erroTicketsDestaque = '';

    this.suporteTicketsService.assuma(ticket.id).then(() => {
      this.carregueFilasOperador();
    }).catch(erro => {
      this.erroTicketsDestaque = erro || 'Não foi possível assumir o ticket.';
    }).finally(() => {
      this.assumindoTicketId = null;
    });
  }

  textoStatusTicket(status: string): string {
    const mapa: any = {
      ABERTO: 'Aberto',
      EM_ANDAMENTO: 'Em andamento',
      AGUARDANDO_CLIENTE: 'Aguardando cliente',
      RESOLVIDO: 'Resolvido',
      CANCELADO: 'Cancelado'
    };

    return mapa[status] || status;
  }

  textoPrioridadeTicket(prioridade: string): string {
    const mapa: any = {
      BAIXA: 'Baixa',
      NORMAL: 'Normal',
      ALTA: 'Alta'
    };

    return mapa[prioridade] || prioridade;
  }

  textoTipoTicket(tipo: string, tipoOutroDescricao?: string): string {
    if (tipo === 'OUTRO' && tipoOutroDescricao) {
      return 'Outro: ' + tipoOutroDescricao;
    }

    const mapa: any = {
      PROBLEMA: 'Problema',
      CONFIGURACAO_CADASTROS: 'Configuração/Cadastros',
      DUVIDA: 'Dúvida',
      SUGESTAO_MELHORIA: 'Sugestão de melhoria',
      CAMPANHA: 'Campanha',
      IMPRESSORA: 'Impressora',
      TREINAMENTO: 'Treinamento',
      IMPLANTACAO: 'Implantação',
      OUTRO: 'Outro'
    };

    return mapa[tipo] || 'Problema';
  }

  textoAreaTicket(areaSistema: string): string {
    const mapa: any = {
      PEDIDOS: 'Pedidos',
      MESAS_COMANDAS: 'Mesas/Comandas',
      CARDAPIO_PRODUTOS: 'Produtos/Cardápio',
      LOJA_CONFIGURACOES: 'Loja/Configurações',
      ENTREGA_TAXAS: 'Entrega/Taxas',
      FORMAS_PAGAMENTO: 'Pagamentos',
      FISCAL_NOTAS: 'Fiscal/Notas',
      WHATSAPP: 'WhatsApp',
      MENSAGENS: 'Mensagens',
      MARKETING_CAMPANHAS: 'Marketing/Campanhas',
      CONTATOS_CRM: 'Contatos/CRM',
      FIDELIDADE: 'Fidelidade',
      MIA_CHATBOT: 'MIA/Chatbot',
      IMPRESSAO_KDS: 'Impressão/KDS',
      INTEGRACOES: 'Integrações',
      OUTRO: 'Outro'
    };

    return mapa[areaSistema] || 'Área não informada';
  }

  classePrioridadeTicket(prioridade: string): string {
    const mapa: any = {
      BAIXA: 'ticket-prioridade-baixa',
      NORMAL: 'ticket-prioridade-normal',
      ALTA: 'ticket-prioridade-alta'
    };

    return mapa[prioridade] || '';
  }

  textoIdadeTicket(ticket: any): string {
    const horas = this.idadeTicketEmHoras(ticket);

    if (horas == null) {
      return 'Idade não informada';
    }

    if (horas < 1) {
      return 'Criado há menos de 1h';
    }

    if (horas < 24) {
      return 'Criado há ' + horas + 'h';
    }

    const dias = Math.floor(horas / 24);
    const horasRestantes = horas % 24;

    return 'Criado há ' + dias + 'd' + (horasRestantes ? ' ' + horasRestantes + 'h' : '');
  }

  classeIdadeTicket(ticket: any): string {
    const horas = this.idadeTicketEmHoras(ticket);

    if (horas == null) {
      return '';
    }

    if (horas >= 168) {
      return 'ticket-idade-critica';
    }

    if (horas >= 72) {
      return 'ticket-idade-alerta';
    }

    return '';
  }

  abraGrupoTicket(ticket: any) {
    if (!ticket || !ticket.grupoWhatsappChatId) {
      return;
    }

    this.whatsappService.abraConversa(ticket.grupoWhatsappChatId);
  }

  abraTicketSuperadmin(ticket: any, event?: Event) {
    const alvo = (event && event.target) as HTMLElement;

    if (alvo && alvo.closest && alvo.closest('a, button')) {
      return;
    }

    if (!ticket || !ticket.id) {
      return;
    }

    window.open('/superadmin/tickets?ticketId=' + encodeURIComponent(ticket.id), '_blank');
  }

  obtenhaLinkAdminEmpresa(ticket: any): string {
    if (!ticket || (!ticket.empresaDominio && !ticket.dominio)) {
      return '';
    }

    return 'https://' + (ticket.empresaDominio || ticket.dominio) + '.promokit.com.br/admin/index';
  }

  obtenhaLinkAdminEmpresaAtual(): string {
    if (!this.empresa || !this.empresa.dominio) {
      return '';
    }

    return 'https://' + this.empresa.dominio + '.promokit.com.br/admin/index';
  }

  obtenhaLinkCardapioDigital(): string {
    if (!this.empresa || !this.empresa.dominio) {
      return '';
    }

    return 'https://' + this.empresa.dominio + '.meucardapio.ai';
  }

  private decode(valor: string): string {
    try {
      return decodeURIComponent(valor || '');
    } catch (e) {
      return valor || '';
    }
  }

  private normalizeNome(valor: any): string {
    if (!valor || valor === 'undefined') {
      return '';
    }

    return String(valor);
  }

  private normalizeTexto(valor: any): string {
    return valor == null ? '' : String(valor).trim();
  }

  private deveExibirClientePkt(): boolean {
    return !!this.grupoId &&
      Number(this.empresa && this.empresa.id) !== 1 &&
      this.obtenhaPrefixoGrupo() === 'PKT';
  }

  private obtenhaPrefixoGrupo(): string {
    const nome = String(this.nomeGrupo || '').trim().toUpperCase();

    if (nome.indexOf('PKT') === 0) {
      return 'PKT';
    }

    if (nome.indexOf('IMPL') === 0) {
      return 'IMPL';
    }

    return '';
  }

  private envieMensagemSolicitacaoNoGrupo(ticket: any, descricao: string) {
    const mensagem = [
      '*SOLICITAÇÃO DE SUPORTE*',
      '',
      'Empresa: ' + (this.empresa && this.empresa.nome ? this.empresa.nome : 'Não informada'),
      ticket && ticket.id ? 'Ticket: #' + ticket.id : '',
      '',
      descricao
    ].filter(linha => linha !== '').join('\n');

    this.whatsappService.envieMensagemNoWhatsapp({
      id: 'suporte-cliente-' + (ticket && ticket.id ? ticket.id : Date.now()),
      telefone: this.grupoId,
      mensagem,
      tipoDeNotificacao: 'Suporte',
      naoRegistrarServidor: true
    });
  }

  private mesmoGrupo(contexto: any): boolean {
    const chatId = contexto && contexto.grupo && contexto.grupo.whatsappChatId;
    return !chatId || chatId === this.grupoId;
  }

  private obtenhaEmpresaSuporteId(): number {
    const empresaSuporte = this.contexto && this.contexto.empresaSuporte;
    return Number(empresaSuporte && empresaSuporte.id);
  }

  private idadeTicketEmHoras(ticket: any): number | null {
    if (!ticket || !ticket.dataCriacao) {
      return null;
    }

    const dataCriacao = new Date(ticket.dataCriacao).getTime();

    if (!dataCriacao) {
      return null;
    }

    return Math.max(0, Math.floor((Date.now() - dataCriacao) / (1000 * 60 * 60)));
  }

  private reinicieEstadoContexto() {
    this.erro = '';
    this.contexto = null;
    this.empresaSelecionada = null;
    this.empresas = [];
    this.termoBusca = '';
    this.buscouEmpresas = false;
    this.buscandoEmpresas = false;
    this.desvinculando = false;
    this.exibindoDesvincular = false;
    this.justificativaDesvinculo = '';
    this.numeroBuscaEmpresas++;
    this.meusTickets = [];
    this.meusTicketsTotal = 0;
    this.carregandoMeusTickets = false;
    this.erroMeusTickets = '';
    this.ticketsDestaque = [];
    this.ticketsDestaqueTotal = 0;
    this.carregandoTicketsDestaque = false;
    this.erroTicketsDestaque = '';
    this.assumindoTicketId = null;
    this.acoesRapidas = null;
    this.carregandoAcoesRapidas = false;
    this.erroAcoesRapidas = '';
    this.aprovandoCampanhaId = null;
    this.fechandoLojaTempo = null;
    this.abrindoLoja = false;
    this.desbloqueandoEmergencial = false;
    this.mensagemFechamentoLoja = '';
    this.acaoRapidaPendente = null;
    this.solicitacaoClienteAcaoRapida = '';
    this.motivoAcaoRapida = '';
    this.erroAcaoRapida = '';
    this.numeroAcoesRapidas++;
    this.clientePkt = false;
    this.exibindoSolicitacaoSuporte = false;
    this.descricaoSolicitacaoSuporte = '';
    this.enviandoSolicitacaoSuporte = false;
    this.erroSolicitacaoSuporte = '';
    this.ticketClienteCriado = null;
    this.contextoClientePkt = null;
    this.carregandoClientePkt = false;
    this.erroClientePkt = '';
  }
}
